import API from "../services/apiservices";

export default { 
  namespaced: true,
  namespace: "clientesStore",

  state: {
    storename: "clientesStore",
    clientes: {
      codigo_cliente: null,
      api: null,
      data: [],
      error: null
    },
    emptyclientes: {
      codigo_cliente: null,
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({ name: "clientesStore", route: "Servicos/Clientes/Get", setter: "setClientes" }),
    gtxClientes: (state) => (state.clientes),
    gtxClientes_data: (state) => (state.clientes.data || []),
    gtxClientes_GetById: (state) => (id) => (state.clientes.data.find(f => f.codigo_cliente == id) || { value: 0, text: "" }),
    gtxClientes_selected: (state) => (state.clientes.data.find(f => f.codigo_cliente == state.clientes.codigo_cliente)),
    gtxClientes_dataoptions: (state) => (state.clientes.data ? state.clientes.data.map(o => ({ value: o.codigo_cliente, text: o.razao_social })).sort((a, b) => a.text.localeCompare(b.text)) : []),
    gtxClientes_codigo_cliente: (state) => (state.clientes.codigo_cliente),
    gtxClientes_razaosocial: (state) => {
      const data = state.clientes.data.find(f => f.codigo_cliente == state.clientes.codigo_cliente);
      return data ? data.razao_social : "";
    },
    gtxClientes_error: (state) => (state.clientes.error),
    gtxClientesEmpty: (state) => (state.emptyclientes),
  },

  mutations: {
    // setClientes: (state, clientes) => (clientes && clientes.apiresponse && clientes.data && clientes.data.length > 0 ? {api: clientes.apiresponse, data: clientes.data, error: null} : state.emptyclientes),
    setClientes: (state, clientes) => {
      if (clientes && clientes.apiresponse && clientes.data && clientes.data.length > 0) {
        state.clientes.api = clientes.apiresponse;
        state.clientes.codigo_cliente = clientes.codigo_cliente;
        state.clientes.data = clientes.data;
        state.clientes.error = null;
      } else { state.clientes = state.emptyclientes }
    },
    setClientescodigo: (state, codigo) => state.clientes.codigo_cliente = codigo,
    setClientesdata: (state, data) => state.clientes.data = data,
  },

  actions: {
    actClientesGet({ commit, getters, dispatch }) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "clientesStore", route: "Servicos/clientes/Get", setter: "setClientes"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", {StoreName: getters.gtxStore.name}, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                dispatch('actClientesCodigo_ClienteGet');
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  dispatch('actClientesCodigo_ClienteGet');
                  res(data);
                }).catch((error) => {
                  API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                    if (doc && doc.data) {
                      commit(getters.gtxStore.setter, doc.data);
                      dispatch('actClientesCodigo_ClienteGet');
                      res(doc.data);
                    } else {
                      const emptyData = { data: [], codigo_cliente: 0, error: error.message };
                      res(emptyData);
                    }
                  });
                });
              }
            });
          }).catch((error) => {
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc && doc.data) {
                commit(getters.gtxStore.setter, doc.data);
                dispatch('actClientesCodigo_ClienteGet');
                res(doc.data);
              } else {
                const emptyData = { data: [], codigo_cliente: 0, error: error.message };
                res(emptyData);
              }
            });
          });
        } catch (err) {
          rej(err);
        }
      });
    },
    actClientesCodigo_ClienteGet({ dispatch }) {
      // atualiza o codigo_cliente
      API.getLocalDBDocument("globalStore").then((doc) => {
        // console.log('actClientesGet', doc);
        if (doc && doc.data && doc.data.codigo_cliente) {
          dispatch('actClientesCodigo_ClienteSet', doc.data.codigo_cliente);
        }
      });
    },
    actClientesCodigo_ClienteSet({ commit }, codigo) {
      // console.log('actClientesCodigo_ClienteSet.codigo', codigo);
      commit("setClientescodigo", codigo);

      API.getLocalDBDocument("globalStore").then((doc) => {
        if (doc && doc.data) {
          doc.data.codigo_cliente = codigo;
          API.setLocalDBDocument({ data: doc.data }, "globalStore");
        } else {
          API.setLocalDBDocument({ data: {codigo_cliente: codigo} }, "globalStore");
        }
      });
    }
  },
};
